import {
  div,
  h3,
  p,
  button,
  input,
  label,
  select,
  option,
  span
} from '@srfnstack/fntags'
import { modalState } from '../state.js'

export const ModalProvider = () => {
  return modalState.bindAs(state => {
    if (!state.isOpen) return div()

    if (state.type === 'prompt' || state.type === 'select') {
      setTimeout(() => {
        const inputEl = document.getElementById('modal-prompt-input')
        if (inputEl) {
          inputEl.focus()
          if (state.type === 'prompt') inputEl.select()
        }
      }, 50)
    }

    const handleConfirm = () => {
      if (state.type === 'mockup-options') {
        const modelEl = document.getElementById('modal-mockup-model')
        const instrEl = document.getElementById('modal-mockup-instructions')
        const framedEl = document.getElementById('modal-mockup-framed')
        state.onConfirm({
          model: modelEl?.value || state.modelValue,
          instructions: instrEl?.value || '',
          framedArtwork: !!framedEl?.checked
        })
      } else if (state.type === 'prompt' || state.type === 'select') {
        const inputEl = document.getElementById('modal-prompt-input')
        state.onConfirm(inputEl ? inputEl.value : '')
      } else {
        state.onConfirm && state.onConfirm()
      }
    }

    const handleCancel = () => {
      state.onCancel && state.onCancel()
    }

    return div({ class: 'modal modal-open' },
      div({ class: 'modal-box' },
        h3({ class: 'font-bold text-lg' }, state.title),
        p({ class: 'py-4' }, state.message),
        state.type === 'prompt'
          ? input({
            id: 'modal-prompt-input',
            type: 'text',
            class: 'input input-bordered w-full mb-4',
            value: state.value,
            onkeydown: (e) => {
              if (e.key === 'Enter') handleConfirm()
              if (e.key === 'Escape') handleCancel()
            }
          })
          : '',
        state.type === 'select'
          ? select({
            id: 'modal-prompt-input',
            class: 'select select-bordered w-full mb-4',
            onchange: (e) => {
              modalState.assign({ value: e.target.value })
            }
          },
          state.options.map(opt => {
            const val = typeof opt === 'string' ? opt : opt.value
            const lbl = typeof opt === 'string' ? opt : opt.label
            return option({ value: val, selected: val === state.value }, lbl)
          })
          )
          : '',
        state.type === 'mockup-options'
          ? div({ class: 'flex flex-col gap-3 mb-4' },
            div({ class: 'form-control' },
              label({ class: 'label py-1' },
                span({ class: 'label-text font-bold text-sm' }, 'Image Model')
              ),
              select({
                id: 'modal-mockup-model',
                class: 'select select-bordered select-sm w-full'
              },
              state.options.map(opt => {
                const val = typeof opt === 'string' ? opt : opt.value
                const lbl = typeof opt === 'string' ? opt : opt.label
                return option({ value: val, selected: val === state.modelValue }, lbl)
              })
              )
            ),
            div({ class: 'form-control' },
              label({ class: 'label py-1' },
                span({ class: 'label-text font-bold text-sm' }, 'Additional Instructions'),
                span({ class: 'label-text-alt opacity-50' }, 'optional')
              ),
              input({
                id: 'modal-mockup-instructions',
                type: 'text',
                class: 'input input-bordered input-sm w-full',
                placeholder: 'e.g. use warm lighting, minimal background...',
                onkeydown: (e) => {
                  if (e.key === 'Enter') handleConfirm()
                  if (e.key === 'Escape') handleCancel()
                }
              })
            ),
            state.showFramedArtwork
              ? div({ class: 'form-control' },
                label({ class: 'label cursor-pointer justify-start gap-3 py-1' },
                  input({
                    id: 'modal-mockup-framed',
                    type: 'checkbox',
                    class: 'checkbox checkbox-sm'
                  }),
                  span({ class: 'label-text text-sm' }, 'Frame is part of the artwork')
                ),
                span({ class: 'label-text-alt opacity-50 pl-9' }, 'Keeps the painted frame border instead of rejecting it')
              )
              : ''
          )
          : '',
        div({ class: 'modal-action' },
          state.type !== 'alert'
            ? button({ class: 'btn btn-ghost', onclick: handleCancel }, 'Cancel')
            : '',
          button({ class: 'btn btn-primary', onclick: handleConfirm }, state.type === 'confirm' ? 'Confirm' : 'OK')
        )
      ),
      div({ class: 'modal-backdrop', onclick: handleCancel })
    )
  })
}
